module.exports = __webpack_public_path__ + "static/media/flag-korea.834c23aa.svg";